'use client';

import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import type { AttrDef } from '../model/moving-item.types';
import { TYPE_DISPLAY } from '../model/moving-item.types';

export interface AttrChipProps {
  attr: AttrDef;
}

export function AttrChip({ attr }: AttrChipProps) {
  const isEnum = attr.type === 'ENUM' && attr.values;
  const chipSx =
    attr.type === 'NUMBER'
      ? {
          fontSize: '0.75rem' as const,
          borderColor: 'info.main',
          color: 'info.main',
          '& .MuiChip-label': {
            color: 'info.main',
            whiteSpace: 'nowrap' as const,
          },
        }
      : attr.type === 'ENUM'
        ? {
            fontSize: '0.75rem' as const,
            borderColor: 'secondary.main',
            color: 'secondary.main',
            '& .MuiChip-label': {
              color: 'secondary.main',
              whiteSpace: 'nowrap' as const,
            },
          }
        : {
            fontSize: '0.75rem' as const,
            '& .MuiChip-label': {
              whiteSpace: 'nowrap' as const,
            },
          };

  const chip = (
    <Chip
      label={`${attr.name ?? attr.key} (${TYPE_DISPLAY[attr.type]})`}
      size="small"
      variant="outlined"
      sx={chipSx}
    />
  );

  if (isEnum && attr.values) {
    return (
      <Tooltip title={`허용 값: ${attr.values.join(', ')}`} placement="top">
        <span style={{ display: 'inline-block' }}>{chip}</span>
      </Tooltip>
    );
  }

  return chip;
}
